// extracted by mini-css-extract-plugin
export default {"markdown":"MarkdownRenderer_markdown__XXmyE"};